const studentUrl = '/student';

export default studentUrl;
